import React from 'react';

const ProspectPushedFailed: React.FC = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="30" height="30" rx="15" fill="#FEE2E2" />
    <g clipPath="url(#prospect-pushed-failed-clip)">
      <path
        d="M17.9896 12.4684C17.9441 12.0107 17.7415 11.5804 17.4134 11.2523C17.0853 10.9241 16.655 10.7216 16.1973 10.6761L15.9993 10.6663C15.4689 10.6663 14.9604 10.8772 14.5853 11.2523C14.2102 11.6274 13.9993 12.1359 13.9993 12.6663L14.0091 12.8643C14.0546 13.322 14.2572 13.7523 14.5853 14.0804C14.9604 14.4555 15.4689 14.6663 15.9993 14.6663L16.1973 14.6566C16.655 14.6111 17.0853 14.4085 17.4134 14.0804C17.7885 13.7053 17.9993 13.1968 17.9993 12.6663L17.9896 12.4684ZM19.3288 12.8317C19.2879 13.6556 18.9422 14.4371 18.3561 15.0231C17.7701 15.6091 16.9886 15.9549 16.1647 15.9958L15.9993 15.9997C15.1153 15.9997 14.2677 15.6482 13.6426 15.0231C13.0565 14.4371 12.7108 13.6556 12.6699 12.8317L12.666 12.6663C12.666 11.7823 13.0175 10.9347 13.6426 10.3096C14.2677 9.68445 15.1153 9.33301 15.9993 9.33301C16.8834 9.33301 17.731 9.68445 18.3561 10.3096C18.9812 10.9347 19.3327 11.7823 19.3327 12.6663L19.3288 12.8317Z"
        fill="#B91C1C"
      />
      <path
        d="M11.334 21.9997V20.6663C11.334 19.7823 11.6854 18.9347 12.3105 18.3096C12.9357 17.6844 13.7833 17.333 14.6673 17.333H17.0007C17.3688 17.333 17.6673 17.6315 17.6673 17.9997C17.6673 18.3679 17.3688 18.6663 17.0007 18.6663H14.6673C14.1369 18.6663 13.6283 18.8772 13.2533 19.2523C12.8782 19.6274 12.6673 20.1359 12.6673 20.6663V21.9997C12.6673 22.3679 12.3688 22.6663 12.0007 22.6663C11.6325 22.6663 11.334 22.3679 11.334 21.9997Z"
        fill="#B91C1C"
      />
      <path
        d="M18.8613 18.8623C19.1216 18.6019 19.5436 18.6019 19.804 18.8623L23.1373 22.1956C23.3977 22.4559 23.3977 22.8779 23.1373 23.1383C22.877 23.3986 22.455 23.3986 22.1946 23.1383L18.8613 19.805C18.6009 19.5446 18.6009 19.1226 18.8613 18.8623Z"
        fill="#B91C1C"
      />
      <path
        d="M22.1946 18.8623C22.455 18.6019 22.877 18.6019 23.1373 18.8623C23.3977 19.1226 23.3977 19.5446 23.1373 19.805L19.804 23.1383C19.5436 23.3986 19.1216 23.3986 18.8613 23.1383C18.6009 22.8779 18.6009 22.4559 18.8613 22.1956L22.1946 18.8623Z"
        fill="#B91C1C"
      />
    </g>
    <defs>
      <clipPath id="prospect-pushed-failed-clip">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export default ProspectPushedFailed;
